import { Component } from '@angular/core';
import { PageOptimizationBase } from '../base/base.component';

@Component({
  selector: 'app-components-specialist-actioncomponents-page-optimization-review-implementation',
  templateUrl: './review-implementation.component.html'
})
export class PageOptimizationReviewImplementationComponent  extends PageOptimizationBase {
  isNoteRequired = false;

  override isStepReadyToReject(): boolean {
    this.noteComponent.isRequired = true;
    return super.isStepReadyToReject();
  }
}